import React, { useState } from "react";
import { Box, TextField, Chip, Autocomplete } from "@mui/material";
import styles from '../createEscalation.module.css';
import EmailRegex from "../../../constants/EmailRegex";

interface EmailAutocompleteProps {
    selectedEmails: string[];
    setSelectedEmails: (emails: string[]) => void;
    inputValue: string;
    setInputValue: (value: string) => void;
    disabled?: boolean;
    singleEmail?: boolean;
}

const EmailAutocomplete: React.FC<EmailAutocompleteProps> = (props) => {
    const {
    selectedEmails,
    setSelectedEmails,
    inputValue,
    setInputValue,
    disabled = false,
    singleEmail = false,
        }  = props;

    const [flagShowError, setFlagShowError] = useState(false);

    const updateEmailList = (email: string) => {
        setSelectedEmails(singleEmail ? [email] : Array.from(new Set([...selectedEmails, email])));
        setInputValue("");
    };

    const handleAddEmail = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key !== "Enter") return;

        event.preventDefault();
        const trimmedEmail = inputValue.trim();

        if (trimmedEmail && EmailRegex.test(trimmedEmail)){
            updateEmailList(trimmedEmail);
        }
    };

    const handleDeleteEmail = (emailToDelete: string) => {
        setSelectedEmails(selectedEmails.filter((email) => email !== emailToDelete));
    };

    const HandleOnBlur = () =>{
        const trimmedEmail = inputValue.trim();
        if(trimmedEmail){
            if(EmailRegex.test(trimmedEmail)){
                updateEmailList(trimmedEmail);
            }else{
                setFlagShowError(true);
            }
        }
    }

    const flagSingleEmail = (selectedEmails.length > 0 && singleEmail)

    return (
        <Box className={styles.autoCompleteOuter}>
            {!flagSingleEmail && <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={selectedEmails}
                className={styles.emailCC}
                inputValue={inputValue}
                onInputChange={(_, newInputValue,reason ) => {
                    setFlagShowError(false);
                    if(reason === "input"){
                        setInputValue(newInputValue)
                    }else if(reason === "clear"){
                        setInputValue("");
                        setSelectedEmails([]);
                    }
                }}
                onBlur={HandleOnBlur}
                disabled={disabled}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            label={option}
                            {...getTagProps({index})}
                            key={option}
                            onDelete={() => handleDeleteEmail(option)}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder={disabled ? undefined: "Enter email and press Enter"}
                        error={flagShowError}
                        onKeyDown={handleAddEmail}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {border: "none"},
                            },
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiInputBase-input": {
                                textDecoration: flagShowError ? "underline 2px dotted red" : "none",
                                textUnderlineOffset: "3px",
                            },
                            "& .MuiInputBase-sizeSmall": {
                                padding: "0 !important",
                            },
                        }}
                    />
                )}
            />}
            {/* Render Chip outside Autocomplete for SingleEmail. */}
            {flagSingleEmail && (
                <Chip
                    disabled={disabled}
                    label={selectedEmails[0]}
                    onDelete={() => {
                        setSelectedEmails([]);
                        setInputValue("")
                    }} // Clear email on delete
                    className={styles.chipStyle}
                />
            )}
        </Box>
    );
};

export default EmailAutocomplete;